import { BusinessCardField, BusinessCardFormProps } from '../../types';

// Fields that are grouped for address (children of address_group / is_saved_address)
const ADDRESS_FIELDS = ['address', 'address2', 'city', 'state', 'zip_code'];

// Fields that trigger phone formatting (inputMode="tel")
const PHONE_FIELDS = ['phone', 'cell_phone', 'fax', 'customer_service_phone', 'toll_free'];

// Skip these meta-fields (they are group toggles, not actual input fields)
const META_FIELDS = ['is_saved_address', 'address_group', 'slight_bar'];

export function BusinessCardForm({ data, onFieldChange, fields }: BusinessCardFormProps) {
  const renderableFields = fields.filter(f => !META_FIELDS.includes(f.key));

  const hasAddressGroup = fields.some(f => f.key === 'address_group' || f.key === 'is_saved_address');

  const orderedFields: BusinessCardField[] = [];
  for (const field of renderableFields) {
    if (ADDRESS_FIELDS.includes(field.key) && hasAddressGroup) continue;
    orderedFields.push(field);
  }

  if (hasAddressGroup && !orderedFields.some(f => ADDRESS_FIELDS.includes(f.key))) {
    ADDRESS_FIELDS.forEach(key => {
      orderedFields.push(fields.find(f => f.key === key) ?? { key, label: key });
    });
  }

  const cityStateZipRow = ['city', 'state', 'zip_code'];
  const renderedCityStateZip = new Set<string>();

  return (
    <div className="space-y-3">
      {orderedFields.map(field => {
        if (renderedCityStateZip.has(field.key)) return null;

        if (cityStateZipRow.includes(field.key)) {
          const rowFields = orderedFields.filter(f => cityStateZipRow.includes(f.key));
          rowFields.forEach(f => renderedCityStateZip.add(f.key));
          return (
            <div key="city-state-zip" className={`grid grid-cols-${rowFields.length} gap-2`}>
              {rowFields.map(f => (
                <div key={f.key}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{f.label}</label>
                  <input
                    type="text"
                    value={data[f.key] || ''}
                    onChange={(e) => onFieldChange(f.key, e.target.value)}
                    placeholder={f.label}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              ))}
            </div>
          );
        }

        return (
          <div key={field.key}>
            <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
            <input
              type="text"
              value={data[field.key] || ''}
              onChange={(e) => onFieldChange(field.key, e.target.value)}
              placeholder={field.label}
              inputMode={PHONE_FIELDS.includes(field.key) ? 'tel' : undefined}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        );
      })}
    </div>
  );
}
